import { ApolloCache, Reference } from '@apollo/client';

// DD-3231: the order lists render straight from the cache. The one list edit the cache cannot
// infer from a mutation result is an order leaving the list.

/** Drops the given orders from every cached page of the list field, under any filter. */
export const removeOrdersFromList = <T>(cache: ApolloCache<T>, listField: string, orderIds: Iterable<string>) => {
    const removed = new Set(orderIds);
    if (!removed.size) return;
    cache.modify({
        id: 'ROOT_QUERY',
        fields: {
            [listField](existing, { readField }) {
                if (!Array.isArray(existing)) return existing;
                return existing.filter((ref: Reference) => !removed.has(readField('_id', ref) as string));
            },
        },
    });
};
